<template>
  <div class="product-bundle-gallery product__gallery-main-image">
    <div
      class="product-bundle-gallery__row flex"
      :class="{ 'product-bundle-gallery__row--duo': isDuo, 'product-bundle-gallery__row--trio': isTrio }"
    >
      <template v-for="collection in otherCollections">
        <BundleGalleryImageItem
          v-for="product in collection.selectedProducts"
          :key="product.variantId"
          :product="product"
          :product-type="productType(collection)"
        />
      </template>
    </div>

    <div
      v-if="sachetsCollection"
      class="product-bundle-gallery__row product-bundle-gallery__row--sachets flex"
      :data-sachet-count="sachetsCollection.selectedProducts?.length"
      :data-sachet-max-count="sachetsCollection.maximumQuantity"
    >
      <div class="inner flex justify-center">
        <BundleGalleryImageItem
          v-for="product in sachetsCollection.selectedProducts"
          :key="product.variantId"
          :product="product"
          :product-type="productType(sachetsCollection)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useBundleStore } from '../pinia/BundleStore'

import BundleGalleryImageItem from './bundle-gallery-image-item'

export default {
  components: {
    BundleGalleryImageItem
  },
  computed: {
    ...mapState (useBundleStore, [
      'bundle',
      'isDuo',
      'isTrio',
      'sachetsCollection',
      'otherCollections'
    ]),
  },
  methods: {
    productType (collection) {
      if (collection?.productType) {
        return collection.productType.toLowerCase()
      }
      let productType = null
      collection.products.forEach(product => {
        if (product.handle.includes('sachet')) {
          productType = 'Sachet'
          return
        }
        if (product.handle.includes('shaker')) {
          productType = 'Shaker'
          return
        }
        if (product.handle.includes('150g') || product.handle.includes('400g') || product.handle.includes('tub')) {
          productType = 'Tub'
        }
      }, productType)
      return productType
    }
  }
}
</script>
